import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchSettings, imgUrl } from "../api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings()
      .then((d) => setSettings(d.data))
      .catch(() => setSettings(null))
      .finally(() => setLoading(false));
  }, []);

  // ── Helpers ──────────────────────────────────────────────────────────────
  const getLogo = () =>
    settings?.logo ? imgUrl(settings.logo) : "/images/FBS_color_logo.png";

  const getBanner = (page) => {
    if (page === "home")
      return settings?.heroBanner ? imgUrl(settings.heroBanner) : null;
    const path = settings?.banners?.[page];
    return path ? imgUrl(path) : null;
  };

  const getHeroHeading = () =>
    settings?.heroHeading?.length ? settings.heroHeading : null;
  const getHeroDesc = () => settings?.heroDescription || null;
  const getAboutFBSImage = () =>
    settings?.aboutFBSImage ? imgUrl(settings.aboutFBSImage) : null;
  const getAboutFBSDesc = () =>
    settings?.aboutFBSDescription?.length ? settings.aboutFBSDescription : null;

  const getContact = () => ({
    phone: settings?.phone || "+91-93678 84939",
    email: settings?.email || "info@franchisebusinesssolution.com",
    address: settings?.address || "New Delhi, India",
  });

  const getSocial = () => settings?.social || {};

  const getFavicons = () => settings?.favicons || null;

  return (
    <SettingsContext.Provider
      value={{
        settings,
        loading,
        getLogo,
        getBanner,
        getHeroHeading,
        getHeroDesc,
        getAboutFBSImage,
        getAboutFBSDesc,
        getContact,
        getSocial,
        getFavicons,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used inside SettingsProvider");
  return ctx;
};
